var map = {
	"./App": 2497,
	"./App.vue": 2497,
	"./Views/AboutView": 2366,
	"./Views/AboutView.vue": 2366,
	"./Views/ContactView": 6666,
	"./Views/ContactView.vue": 6666,
	"./Views/FlooringView": 1480,
	"./Views/FlooringView.vue": 1480,
	"./Views/HomeView": 2654,
	"./Views/HomeView.vue": 2654,
	"./Views/LandscapingView": 2372,
	"./Views/LandscapingView.vue": 2372,
	"./Views/MetalRoofingView": 7085,
	"./Views/MetalRoofingView.vue": 7085,
	"./Views/NotFoundView": 7146,
	"./Views/NotFoundView.vue": 7146,
	"./Views/PaintingDrywalsView": 3565,
	"./Views/PaintingDrywalsView.vue": 3565,
	"./Views/PlatinumProMovingView": 9755,
	"./Views/PlatinumProMovingView.vue": 9755,
	"./Views/ServicesView": 2349,
	"./Views/ServicesView.vue": 2349,
	"./Views/WindowsAndDoorsView": 1975,
	"./Views/WindowsAndDoorsView.vue": 1975,
	"./assets/fonts/Arial-BoldMT.eot": 9501,
	"./assets/fonts/Arial-BoldMT.ttf": 2864,
	"./assets/fonts/Arial-BoldMT.woff": 3617,
	"./assets/fonts/Arial-BoldMT.woff2": 5879,
	"./assets/fonts/ArialMT.eot": 8861,
	"./assets/fonts/ArialMT.ttf": 6223,
	"./assets/fonts/ArialMT.woff": 5184,
	"./assets/fonts/ArialMT.woff2": 681,
	"./assets/fonts/BarlowCondensed-Regular.eot": 621,
	"./assets/fonts/BarlowCondensed-Regular.ttf": 5292,
	"./assets/fonts/BarlowCondensed-Regular.woff": 9418,
	"./assets/fonts/BarlowCondensed-Regular.woff2": 4490,
	"./assets/fonts/Inter-Bold.eot": 1044,
	"./assets/fonts/Inter-Bold.ttf": 9436,
	"./assets/fonts/Inter-Bold.woff": 6759,
	"./assets/fonts/Inter-Bold.woff2": 6570,
	"./assets/fonts/fonts.css": 4465,
	"./assets/icons/arrow-1.svg": 4622,
	"./assets/icons/email.svg": 7882,
	"./assets/icons/flooring.svg": 6409,
	"./assets/icons/landscaping.svg": 1110,
	"./assets/icons/metal-roofing.svg": 1892,
	"./assets/icons/painting-drywalls.svg": 8635,
	"./assets/icons/phone.svg": 9193,
	"./assets/icons/quote.svg": 3476,
	"./assets/icons/windows-doors.svg": 2446,
	"./assets/images/about/about-cards.jpg": 9644,
	"./assets/images/about/about-overall.jpg": 9658,
	"./assets/images/about/about-top.jpg": 8790,
	"./assets/images/contact-form-bg.jpg": 3251,
	"./assets/images/contact-top-bg.jpg": 2523,
	"./assets/images/flooring/main-cards.jpg": 5783,
	"./assets/images/flooring/main-list.jpg": 3828,
	"./assets/images/flooring/overall-1.jpg": 6647,
	"./assets/images/flooring/overall-2.jpg": 3004,
	"./assets/images/flooring/top.jpg": 7497,
	"./assets/images/home-our-vision.jpg": 7827,
	"./assets/images/home-reviews.jpg": 3393,
	"./assets/images/home-services.jpg": 9004,
	"./assets/images/home-top.jpg": 9602,
	"./assets/images/landscaping/main.jpg": 2586,
	"./assets/images/landscaping/top.jpg": 7570,
	"./assets/images/metal-roofing/image 1.jpg": 1509,
	"./assets/images/metal-roofing/image 10.jpg": 1139,
	"./assets/images/metal-roofing/image 11.jpg": 2286,
	"./assets/images/metal-roofing/image 12.jpg": 443,
	"./assets/images/metal-roofing/image 13.jpg": 5185,
	"./assets/images/metal-roofing/image 14.jpg": 7645,
	"./assets/images/metal-roofing/image 15.jpg": 5388,
	"./assets/images/metal-roofing/image 16.jpg": 1566,
	"./assets/images/metal-roofing/image 17.jpg": 4018,
	"./assets/images/metal-roofing/image 18.jpg": 5978,
	"./assets/images/metal-roofing/image 2.jpg": 5877,
	"./assets/images/metal-roofing/image 3.jpg": 7374,
	"./assets/images/metal-roofing/image 4.jpg": 5691,
	"./assets/images/metal-roofing/image 5.jpg": 9043,
	"./assets/images/metal-roofing/image 6.jpg": 3497,
	"./assets/images/metal-roofing/image 7.jpg": 2748,
	"./assets/images/metal-roofing/image 8.jpg": 9761,
	"./assets/images/metal-roofing/image 9.jpg": 2463,
	"./assets/images/metal-roofing/metal-roofing-list.jpg": 1107,
	"./assets/images/metal-roofing/metal-roofing-top.jpg": 9984,
	"./assets/images/not-found.gif": 2000,
	"./assets/images/painting-and-drywalls/image 1.jpg": 7531,
	"./assets/images/painting-and-drywalls/image 10.jpg": 4262,
	"./assets/images/painting-and-drywalls/image 11.jpg": 968,
	"./assets/images/painting-and-drywalls/image 12.jpg": 5970,
	"./assets/images/painting-and-drywalls/image 13.jpg": 1096,
	"./assets/images/painting-and-drywalls/image 14.jpg": 6447,
	"./assets/images/painting-and-drywalls/image 15.jpg": 625,
	"./assets/images/painting-and-drywalls/image 16.jpg": 3887,
	"./assets/images/painting-and-drywalls/image 17.jpg": 6588,
	"./assets/images/painting-and-drywalls/image 18.jpg": 9452,
	"./assets/images/painting-and-drywalls/image 2.jpg": 3981,
	"./assets/images/painting-and-drywalls/image 3.jpg": 9765,
	"./assets/images/painting-and-drywalls/image 4.jpg": 3751,
	"./assets/images/painting-and-drywalls/image 5.jpg": 8945,
	"./assets/images/painting-and-drywalls/image 6.jpg": 889,
	"./assets/images/painting-and-drywalls/image 7.jpg": 6423,
	"./assets/images/painting-and-drywalls/image 8.jpg": 2458,
	"./assets/images/painting-and-drywalls/image 9.jpg": 1333,
	"./assets/images/painting-and-drywalls/painting-and-drywalls__main-info.jpg": 7110,
	"./assets/images/painting-and-drywalls/painting-and-drywalls__top.jpg": 5458,
	"./assets/images/platinum-pro-moving/image 1.jpg": 1969,
	"./assets/images/platinum-pro-moving/image 2.jpg": 9098,
	"./assets/images/platinum-pro-moving/main.jpg": 8706,
	"./assets/images/platinum-pro-moving/top.jpg": 8845,
	"./assets/images/services-card-1.jpg": 7205,
	"./assets/images/services-card-2.jpg": 9873,
	"./assets/images/services-card-3.jpg": 1494,
	"./assets/images/services-card-4.jpg": 6449,
	"./assets/images/services-card-5.jpg": 50,
	"./assets/images/services-top.jpg": 6634,
	"./assets/images/windows-doors/image 1.jpg": 6776,
	"./assets/images/windows-doors/image 10.jpg": 2746,
	"./assets/images/windows-doors/image 11.jpg": 5752,
	"./assets/images/windows-doors/image 12.jpg": 9537,
	"./assets/images/windows-doors/image 2.jpg": 823,
	"./assets/images/windows-doors/image 3.jpg": 7014,
	"./assets/images/windows-doors/image 4.jpg": 2768,
	"./assets/images/windows-doors/image 5.jpg": 5639,
	"./assets/images/windows-doors/image 6.jpg": 5900,
	"./assets/images/windows-doors/image 7.jpg": 6483,
	"./assets/images/windows-doors/image 8.jpg": 3203,
	"./assets/images/windows-doors/image 9.jpg": 7230,
	"./assets/images/windows-doors/windows-doors__main-info.jpg": 7181,
	"./assets/images/windows-doors/windows-doors__top.jpg": 3442,
	"./assets/styles/main.css": 3405,
	"./assets/styles/reset.css": 2242,
	"./components/BurgerMenuComp": 6034,
	"./components/BurgerMenuComp.vue": 6034,
	"./components/ContacInfoComp": 6317,
	"./components/ContacInfoComp.vue": 6317,
	"./components/DiscoverComp": 4022,
	"./components/DiscoverComp.vue": 4022,
	"./components/FooterComp": 2152,
	"./components/FooterComp.vue": 2152,
	"./components/FormComp": 9231,
	"./components/FormComp.vue": 9231,
	"./components/HeaderComp": 8588,
	"./components/HeaderComp.vue": 8588,
	"./components/ListComp": 9882,
	"./components/ListComp.vue": 9882,
	"./components/LogoComp": 273,
	"./components/LogoComp.vue": 273,
	"./components/MainInfoComp": 6160,
	"./components/MainInfoComp.vue": 6160,
	"./components/NavigationComp": 836,
	"./components/NavigationComp.vue": 836,
	"./components/OurVisionComp": 4304,
	"./components/OurVisionComp.vue": 4304,
	"./components/OverallComp": 2448,
	"./components/OverallComp.vue": 2448,
	"./components/OverallTwoImgComp": 5070,
	"./components/OverallTwoImgComp.vue": 5070,
	"./components/ReviewsComp": 750,
	"./components/ReviewsComp.vue": 750,
	"./components/ServicesComp": 4461,
	"./components/ServicesComp.vue": 4461,
	"./components/SwiperComp": 8110,
	"./components/SwiperComp.vue": 8110,
	"./components/TitleComp": 6433,
	"./components/TitleComp.vue": 6433,
	"./components/TopComp": 6443,
	"./components/TopComp.vue": 6443,
	"./main": 866,
	"./main.js": 866,
	"./routes": 9149,
	"./routes/": 9149,
	"./routes/index": 9149,
	"./routes/index.js": 9149,
	"./routes/routes": 5559,
	"./routes/routes.js": 5559
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8116;